<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="" class="query-form-item" style="float:right;margin-right:6px;">
                <el-button size="mini" @click="onDownloadList">下载列表</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            style="width: 100%;">
            <el-table-column
                label="ID"
                width="80"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="ASIN"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin }}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="广告数据记录id"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.ad_data_record }}</div>
                </template>
            </el-table-column> -->
            <el-table-column
                label="项目组"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.project_name }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="国家"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.state }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="开始日期"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="结束日期"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="目标acos"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.target_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="产品价格"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.product_price }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="点击数"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.clicks }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="大于目标acos"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.tower_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="高点击无出单的乘数"
                width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.high_click_not_order }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="低点击无出单的乘数"
                width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.low_click_not_order }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="排除的活动"
                min-width="200"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.exclude_activity }}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="状态"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.download_tag == 1" type="success">完成</el-tag>
                    <el-tag v-else-if="scope.row.download_tag == 0" type="info">未完成</el-tag>
                    <el-tag v-else-if="scope.row.download_tag == -1" type="danger">失败</el-tag>
                </template>
            </el-table-column> -->
            <el-table-column
                label="上传时间"
                width="144"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time.replace(/T/g, " ") }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="110">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini" @click="delete_file(scope.row)">删除</el-button>
                    <el-button style="margin: 5px 0 5px 10px" type="primary" size="mini" @click="downloadAddBetter(scope.row)">下载</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; padding-bottom: 30px"
            layout="total, sizes, prev, pager, next">
        </el-pagination>
        <DownloadList :activeName="activeName" :visible="ctrl.DownloadListDialogVisible" :title="'下载列表'" @close-callback="closeCllback">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="广告优化" name="ad" style="padding: 0 25px;">
                    <DownloadView ref="ad" :task_type="3"></DownloadView>
                </el-tab-pane>
            </el-tabs>
        </DownloadList>
    </div>
</template>

<script>
import * as api from "@/api/statistics/statistics";
import { binary_download } from "@/utils/method";
import DownloadList from "./downloadList";
import DownloadView from "./downloadView";
export default {
    components: { DownloadList, DownloadView },
    data() {
        return {
            tableHeight: null,
            ctrl: {
                DownloadListDialogVisible: false
            },
            query: {
                page: 1,
                limit: 20,
                total: 0,
                asin: ""
            },
            activeName: "ad",
            list: [],
            disabled: false,
            loading: false
        };
    },
    created() {
        this.query.asin = this.$route.query.asin;
    },
    mounted() {
        this.tableHeight = window.innerHeight - 140;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight = window.innerHeight - 140;
                }
            })();
        };
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    methods: {
        getList() {
            this.loading = true;
            api.ppc_optimize_show(this.query)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.detail_list;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList();
            });
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true;
            this.$nextTick(() => {
                this.$refs[this.activeName].getList();
            });
        },
        downloadAddBetter(row) {
            if (!row.file_path) {
                return this.$message({
                    type: "error",
                    message: "无法下载！"
                });
            }
            binary_download(
                "/apis/v1/common_file_export_by_path",
                "post",
                {},
                {
                    file_path: row.file_path
                },
                "application/vnd.ms-excel",
                row.project_name
            );
        },
        //删除
        delete_file(data) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.ppc_optimize_delete({
                        id: data.id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.DownloadListDialogVisible = false;
            isshow == true && this.getList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
